import { getImagePagePaths, getImagePage } from '../../lib/image_page'
import {wrapper} from "../../store/store";
import * as staticProps from '../../lib/static_props'
import ImagePagePage, {ImagePagePageParams} from '../[countryCode]/ipage/[pagePath]'
import {withRedirectForNoCountryCode} from "../../components/with_redirect_for_no_country_code";
import moment from "moment";

export const getStaticProps = wrapper.getStaticProps(store => async (context) => {
	const params = context.params as ImagePagePageParams;

	await staticProps.populateServerSideStore(store.dispatch)
	const imagePage = await getImagePage(params.pagePath)
	return {
		props: {
			imagePage,
		},
		revalidate: moment.duration(1, 'day').as('seconds'),
	}
})

export async function getStaticPaths() {
	const paths = await getImagePagePaths()
	return {
		paths,
		fallback: true,
	}
}

export default withRedirectForNoCountryCode(ImagePagePage)